module.exports = __webpack_public_path__ + "img/petrol.ae16aaf4.svg";